import * as React from "react";
// UI Frameworks
import { Form } from "antd";
import { FormComponentProps } from "antd/lib/form";
// Shared components
import Input from "components/Input";
import Button from "components/Button";
// Styles
import styles from "./index.module.scss";

interface ISubmitData {
	mobile: string;
}
interface IProps extends FormComponentProps {
	loading: boolean;
	question: string;
	onSubmit: (data: ISubmitData) => void;
}
const AnswerQuestion: React.FC<IProps> = props => {
	const { getFieldDecorator } = props.form;

	function handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
		e.preventDefault();

		props.form.validateFieldsAndScroll((err, values) => {
			if (!err) {
				props.onSubmit(values);

				return;
			}
		});
	}

	return (
		<Form className={styles["send-sms-form"]} onSubmit={handleSubmit}>
			<Form.Item label={props.question}>
				{getFieldDecorator("answer", {
					rules: [
						{
							required: true,
							transform: value => (value ? value.trim() : value),
							message: "لطفا پاسخ سوال را وارد نمایید",
						},
					],
				})(<Input />)}
			</Form.Item>

			<Form.Item className="button-center">
				<Button htmlType="submit" primary loading={props.loading}>
					ارسال پاسخ
				</Button>
			</Form.Item>
		</Form>
	);
};

export default Form.create<IProps>()(React.memo(AnswerQuestion));
